// extracted by mini-css-extract-plugin
export default {"myBtn":"Button_green_myBtn__nKunC"};